/* eslint-disable */

//
import { Component } from "react"
import PropTypes from "prop-types"

import { isFeatureEnabled } from "shared/featureflags/helperFunctions"

import { createOrderByFilterGroup, genericFilterGroup } from "shared/search/containers/FilterGroup/FilterGroups"
import { createCustomFilterGroup } from "shared/search/containers/FilterGroup/CustomFilterGroup"

import { federalAndStates, euRegion, euRegions } from "shared/imports/regionConstants"

import {
    createListFilter,
    createNotInListFilter,
    ManuallyChangedInListFilter,
    LegislativeSessionFilter,
    PriorityFilter,
    PriorityLastUserFilter,
    RegionCountryEUFilter,
    StanceFilter,
    StanceLastUserFilter,
    CustomRegionFilter,
    BillExcludeUSStatesFilter,
    ReviewedByMeFilter,
    ReviewedByOrgFilter,
    ReviewedByTeamFilter,
    ReviewedByUserFilter,
    NotReviewedByUserFilter,
} from "shared/search/containers/Filter/Filters"

import { inIssueFilter, notInIssueFilter } from "shared/search/containers/Filter/FilterCreators"

import {
    BillLegYearNewFilter,
    BillLegCurrentSessionFilter,
    BillDateListFilter,
    BillDateAfterFilter,
    BillDateBeforeFilter,
    BillMostRecentDateListFilter,
    BillMostRecentDateAfterFilter,
    BillMostRecentDateBeforeFilter,
    BillMostRecentTextDateListFilter,
    BillMostRecentTextDateAfterFilter,
    BillMostRecentTextDateBeforeFilter,
    BillDateStatusListFilter,
    BillTypeFilter,
    BillIsAppropsBillFilter,
    BillGeneralStatusFilter,
    BillGlobalStatusFilter,
    BillActionAfterFilter,
    BillActionBeforeFilter,
    BillDateOfHearingListFilter,
    BillTitleFilter,
    BillTermFilter,
    BillHearingFilter,
    BillCommitteeFilter,
    BillCommitteeTypeFilter,
    BillCompanionFilter,
    BillSponsorFilter,
    BillSponsorsCountFilter,
    BillMaleCoSponsorsCountFilter,
    BillFemaleCoSponsorsCountFilter,
    BillRepublicanCoSponsorsCountFilter,
    BillDemocratCoSponsorsCountFilter,
    BillIndependentCoSponsorsCountFilter,
    BillCosponsorFilter,
    BillNotCosponsorFilter,
    BillSponsorOrCosponsorFilter,
    BillRelatedFilter,
    BillFromBulkUploadFilter,
    BillTrackingDashboardFilter,
    BillSupportedRegionsFilter,
    BillGlobalRegionsFilter,
    BillLanguageFilter,
    // invisible
    BillInvisiblePartyFilter,
    BillInvisibleSingleYearFilter,
    BillInvisibleWithoutStanceFilter,
    BillInvisibleStatusFilter,
    BillInvisibleRegionFilter,
    BillInvisibleSlugSearchFilter,
    // profile specific
    BillSponsorOfficialProfileFilter,
    // Organization profile
    BillOrganizatonsFilter,
    // Committee profile
    BillCommitteProfileFilter,
    // eu
    BillSponsorTypeFilter,
    BillSponsorEUFilter,
    EULegislationTypeFilter,
    InitiativeDetailedStatusFilter,
} from "shared/search/containers/Filter/BillFilters"

import { bulkUploadIsAvailable } from "shared/search/helperFunctions"

const defaultProps = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}

export const BillCustomFilterGroup = createCustomFilterGroup(
    "billCustomFilterGroup",
    DjangIO.app.models.QuorumDataType.bill.value,
)

export class BillDateFilterGroup extends Component {
    static defaultProps = {
        filters: [
            BillLegYearNewFilter,
            LegislativeSessionFilter,
            BillLegCurrentSessionFilter,
            BillDateListFilter,
            BillDateAfterFilter,
            BillDateBeforeFilter,
        ],
        uniqueFilterGroupId: "billDateFilterGroup",
        displayLabel: "Date",
        helpText:
            "Filter bills by their session, date introduced, or relevant year. " +
            "A bill can be relevant in multiple years due to multi-year sessions, carryover, etc.",
        dataCy: "bill-date-filter-group",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class BillTypeFilterGroup extends Component {
    static defaultProps = {
        filters: [Userdata.isOnlyEUMode() ? EULegislationTypeFilter : BillTypeFilter, BillIsAppropsBillFilter],
        uniqueFilterGroupId: "billTypeFilterGroup",
        displayLabel: `${DjangIO.app.models.QuorumDataType.bill.singular} Type`,
        helpText: "Filter bills by chamber in which they were introduced or by type of bill / resolution.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class BillLanguageFilterGroup extends Component {
    static defaultProps = {
        filters: [BillLanguageFilter],
        uniqueFilterGroupId: "billLanguageFilterGroup",
        displayLabel: "Language",
        helpText: "Provides more accurate results based on the language selection.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class BillTitleFilterGroup extends Component {
    static defaultProps = {
        filters: [BillTitleFilter],
        uniqueFilterGroupId: "billTitleFilterGroup",
        displayLabel: Userdata.isOnlyEUMode() ? "Procedure Reference" : "Title",
        helpText: `Search ${DjangIO.app.models.QuorumDataType.bill.singular} by title.`,
        dataCy: "bill-title-filter-group",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class BillSupportedRegionFilterGroup extends Component {
    static defaultProps = {
        filters: Userdata.isGlobalMode()
            ? [BillGlobalRegionsFilter, BillExcludeUSStatesFilter]
            : [
                  // SupportedRegion.all_regions (All US)
                  BillSupportedRegionsFilter,
                  // SupportedRegion.states
                  CustomRegionFilter,
                  // SupportedRegion.eu
                  RegionCountryEUFilter,
              ],
        uniqueFilterGroupId: "regionFilterGroup",
        displayLabel: "Region",
        helpText: "Filter results by a single region or a group of regions.",
        dataCy: "bill-region-filter-group",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class BillStatusFilterGroup extends Component {
    static defaultProps = {
        filters: [
            ...(Userdata.isGlobalMode() ? [BillGlobalStatusFilter] : [BillGeneralStatusFilter]),
            ...(Userdata.isOnlyEUMode() ? [InitiativeDetailedStatusFilter] : []),
            BillMostRecentDateListFilter,
            BillMostRecentDateAfterFilter,
            BillMostRecentDateBeforeFilter,
            BillDateStatusListFilter,
            BillActionAfterFilter,
            BillActionBeforeFilter,
            BillDateOfHearingListFilter,
            BillMostRecentTextDateListFilter,
            BillMostRecentTextDateAfterFilter,
            BillMostRecentTextDateBeforeFilter,
        ],
        uniqueFilterGroupId: "billStatusFilterGroup",
        displayLabel: "Current Status",
        helpText:
            "Filter bills or nominations by milestones (ie. introduced, enacted), a particular status, " +
            "or by date of the last change in status.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class BillTermFilterGroup extends Component {
    static defaultProps = {
        filters: [BillTermFilter],
        uniqueFilterGroupId: "billTermFilterGroup",
        displayLabel: "Legislative Issues",
        regions: federalAndStates,
        helpText:
            "Filter bills by issue area. At the federal level, we use " +
            "issue areas as determined by the Congressional Research Service. At " +
            "the state level, we use machine learning to assign multiple issue " +
            "areas to each bill.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class BillCommitteeFilterGroup extends Component {
    static defaultProps = {
        filters: [BillHearingFilter, BillCommitteeFilter, BillCommitteeTypeFilter],
        uniqueFilterGroupId: "billCommitteeFilterGroup",
        displayLabel: "Committees",
        regions: federalAndStates,
        helpText: "Filter bills by the committee(s) to which they were referred.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class BillSponsorFilterGroup extends Component {
    static defaultProps = {
        filters: [
            BillSponsorFilter,
            BillCosponsorFilter,
            BillNotCosponsorFilter,
            BillSponsorOrCosponsorFilter,
            BillSponsorsCountFilter,
            BillMaleCoSponsorsCountFilter,
            BillFemaleCoSponsorsCountFilter,
            BillRepublicanCoSponsorsCountFilter,
            BillDemocratCoSponsorsCountFilter,
            BillIndependentCoSponsorsCountFilter,
        ],
        uniqueFilterGroupId: "billSponsorFilterGroup",
        displayLabel: Userdata.has_international_region ? "Key Players" : "Sponsors",
        helpText: "Filter bills by the legislators that sponsored or cosponsored them.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class BillSourceFilterGroup extends Component {
    static defaultProps = {
        filters: [BillSponsorEUFilter, BillSponsorTypeFilter],
        uniqueFilterGroupId: "billSourceFilterGroup",
        displayLabel: "Source",
        regions: euRegion,
        helpText: "Filter legislation by its relevant rapporteur, shadow rapporteur, committee, etc.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class BillListFilterGroup extends Component {
    static defaultProps = {
        filters: [
            createListFilter(DjangIO.app.models.QuorumDataType.bill.value),
            createNotInListFilter(DjangIO.app.models.QuorumDataType.bill.value),
            ManuallyChangedInListFilter,
        ],
        uniqueFilterGroupId: "billListFilterGroup",
        displayLabel: "Lists",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class BillStanceFilterGroup extends Component {
    static defaultProps = {
        filters: [StanceFilter, StanceLastUserFilter],
        uniqueFilterGroupId: "billStanceFilterGroup",
        displayLabel: "Stance",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class BillPriorityFilterGroup extends Component {
    static defaultProps = {
        filters: [PriorityFilter, PriorityLastUserFilter],
        uniqueFilterGroupId: "billPriorityFilterGroup",
        displayLabel: "Priority",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class BillRelatedFilterGroup extends Component {
    static defaultProps = {
        filters: [BillRelatedFilter],
        uniqueFilterGroupId: "billRelatedFilterGroup",
        displayLabel: "Related Bills",
        regions: federalAndStates,
        helpText:
            "Filter by bills that are similar to a specific bill. In both " +
            "state and federal, we use natural language processing to find bills that are " +
            "contained by or similar to this particular bill based on their language. " +
            "At the federal level, we also include bills that the Congressional Research Service " +
            "has marked as companion or related bills.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class BillCompanionFilterGroup extends Component {
    static defaultProps = {
        filters: [BillCompanionFilter],
        uniqueFilterGroupId: "billCompanionFilterGroup",
        displayLabel: "Companion Bills",
        regions: federalAndStates,
        helpText: "Show companion bills",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class BillInvisibleFilterGroup extends Component {
    static defaultProps = {
        filters: [
            BillInvisiblePartyFilter,
            BillInvisibleSingleYearFilter,
            BillInvisibleWithoutStanceFilter,
            BillInvisibleStatusFilter,
            BillInvisibleRegionFilter,
            BillInvisibleSlugSearchFilter,
        ],
        uniqueFilterGroupId: "billInvisibleFilterGroup",
        invisible: true,
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class BillDataMaintenanceFilterGroup extends Component {
    static defaultProps = {
        filters: bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.bill)
            ? [BillFromBulkUploadFilter]
            : [],
        uniqueFilterGroupId: "officialDataMaintenanceFilterGroup",
        displayLabel: "Data Maintenance",
        helpText: "Filter bills by source.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export const BillSponsorOfficialProfileFilterGroup = (props) => genericFilterGroup(props)
BillSponsorOfficialProfileFilterGroup.propTypes = defaultProps
BillSponsorOfficialProfileFilterGroup.defaultProps = {
    filters: [BillSponsorOfficialProfileFilter],
    uniqueFilterGroupId: "BillSponsorOfficialProfileFilterGroup",
    noHeader: true,
    alwaysOpen: true,
}

export const BillOrganizationProfileFilterGroup = (props) => genericFilterGroup(props)
BillOrganizationProfileFilterGroup.propTypes = defaultProps
BillOrganizationProfileFilterGroup.defaultProps = {
    filters: [BillOrganizatonsFilter],
    uniqueFilterGroupId: "billOrganizationProfileFilterGroup",
    noHeader: true,
    alwaysOpen: true,
}

export const BillProjectFilterGroup = (props) => genericFilterGroup(props)
BillProjectFilterGroup.propTypes = defaultProps
BillProjectFilterGroup.defaultProps = {
    filters: [inIssueFilter, notInIssueFilter],
    uniqueFilterGroupId: "billProjectFilterGroup",
    displayLabel: "Issues",
}

export const BillTrackingDashboardFilterGroup = (props) => genericFilterGroup(props)
BillTrackingDashboardFilterGroup.propTypes = defaultProps
BillTrackingDashboardFilterGroup.defaultProps = {
    filters: [BillTrackingDashboardFilter],
    uniqueFilterGroupId: "billTrackingDashboardFilterGroup",
    displayLabel: "Tracking Boards",
    helpText: "Filter for results that currently appear on the unreviewed bills tab in your tracking board(s).",
}

export const BillCommitteeProfileFilterGroup = (props) => genericFilterGroup(props)
BillCommitteeProfileFilterGroup.propTypes = defaultProps
BillCommitteeProfileFilterGroup.defaultProps = {
    filters: [BillCommitteProfileFilter],
    uniqueFilterGroupId: "billCommitteeProfileFilterGroup",
    noHeader: true,
    alwaysOpen: true,
}

export const BillOrderByFilterGroup = createOrderByFilterGroup({
    // uniqueFilterId = "billOrderBy"
    quorumDataType: DjangIO.app.models.QuorumDataType.bill.value,
})

export const BillReviewFilterGroup = (props) => genericFilterGroup(props)
BillReviewFilterGroup.propTypes = defaultProps
BillReviewFilterGroup.defaultProps = {
    filters: [
        ReviewedByMeFilter,
        ReviewedByOrgFilter,
        ReviewedByUserFilter,
        ReviewedByTeamFilter,
        NotReviewedByUserFilter,
    ],
    uniqueFilterGroupId: "billReviewFilterGroup",
    displayLabel: "Review Status",
    helpText: "Filter results by review status of bill",
}

/* eslint-enable */
